import React, {useState} from 'react';
import HeroProj from "../Projects/HeroProj";


//use for job related stuff
function Encompass(props) {
    const [coord, setCoord] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        setCoord({ x: e.screenX, y: e.screenY });
    };
    return (

        <div>

            <HeroProj title='Encompass related'/>
            <h2 onMouseMove={handleMouseMove}>
                "mouse location: (in h2)"  {coord.x} : {coord.y} </h2>

        </div>
    );
}

export default Encompass;